import React, { useState, useRef, useEffect } from "react";

const DiscoveryDropdown = ({ 
  value, 
  onChange, 
  options = [], 
  placeholder, 
  disabled = false,
  displayProperty = "name",
  valueProperty = "id",
  noOptionsText = "No options found"
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getDisplayValue = () => {
    if (!value) return placeholder;
    const selected = options.find(opt => opt[valueProperty] === value);
    return selected ? selected[displayProperty] : placeholder;
  };

  const handleSelect = (optionValue) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
        className={`w-full appearance-none bg-white border border-[#D2D4D8] rounded-lg pl-4 pr-10 py-2 h-[42px] text-[16px] text-[#1E1E1ECC] font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 text-left flex items-center ${
          disabled ? 'opacity-70 cursor-not-allowed' : ''
        }`}
      >
        <span className={`truncate ${value ? 'text-[#1E1E1ECC]' : 'text-[#1E1E1ECC]'}`}>
          {getDisplayValue()}
        </span>
      </button>
      
      <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
        <svg
          className="w-4 h-4 text-[#1E1E1ECC]"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </div>

      {isOpen && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-[#D2D4D8] rounded-lg shadow-lg max-h-60 overflow-auto">
          {options.length > 0 ? (
            options.map((option) => (
              <button
                key={option[valueProperty]}
                type="button"
                className="w-full px-4 py-2 text-left text-[16px] text-[#1E1E1ECC] hover:bg-gray-50 font-medium"
                onClick={() => handleSelect(option[valueProperty])}
              >
                {option[displayProperty]}
              </button>
            ))
          ) : (
            <div className="px-4 py-2 text-[16px] text-[#1E1E1ECC]">
              {noOptionsText}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DiscoveryDropdown;
